<template>
    <div class="close-workList">
        <mc-operate-bar>
            <template slot="left">
                <mc-search-bar v-model="searchParmas" search-label="输入工单号/站点名称/工单标题" :search-submit="$_getTableList"></mc-search-bar>
                <el-button type="primary" style="margin-left:10px;" @click="exSearch=!exSearch">高级搜索<i :class="{
                      'el-icon-arrow-down':!exSearch,
                      'el-icon-arrow-up':exSearch,
                  }"></i></el-button>
            </template>
        </mc-operate-bar>

        <div class="exSearch-row" v-if="exSearch">
            <div class="exSearch-line">
                <div class="exSearch-item">
                    <el-select v-model="advancedSearch.siteList.value" style="width:200px;" multiple placeholder="请选择站点">
                        <el-option v-for="item in advancedSearch.siteList.list" :key="item.site_id" :label="item.site_name"
                            :value="item.site_id">
                        </el-option>
                    </el-select>
                </div>
                <div class="exSearch-item">
                    <el-select v-model="advancedSearch.userList.value" style="width:200px;" multiple placeholder="请选择工单所有者">
                        <el-option v-for="item in advancedSearch.userList.list" :key="item.user_id" :label="item.user_name"
                            :value="item.user_id">
                        </el-option>
                    </el-select>
                </div>
                <div class="exSearch-item">
                    <el-select v-model="advancedSearch.worksheetType.value" style="width:200px;" multiple placeholder="请选择工单类型">
                        <el-option v-for="item in advancedSearch.worksheetType.list" :key="item.value" :label="item.name"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <div class="exSearch-item">
                    <el-select v-model="advancedSearch.eventType.value" style="width:200px;" multiple placeholder="请选择事件类型">
                        <el-option v-for="item in advancedSearch.eventType.list" :key="item.value" :label="item.name"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <div class="exSearch-item">
                    <el-select style="width:200px;" v-model="advancedSearch.noData" placeholder="已关闭" disabled>
                    </el-select>
                </div>
            </div>
            <div class="exSearch-line">
                <div class="exSearch-item">
                    <el-date-picker v-model="advancedSearch.timeSet.createStart" type="datetime" style="width:200px;"
                        placeholder="创建开始时间">
                    </el-date-picker>
                </div>
                <div class="exSearch-item">
                    <el-date-picker v-model="advancedSearch.timeSet.createEnd" type="datetime" style="width:200px;"
                        placeholder="创建结束时间">
                    </el-date-picker>
                </div>
                <div class="exSearch-item">
                    <el-date-picker v-model="advancedSearch.timeSet.closeStart" type="datetime" style="width:200px;"
                        placeholder="关闭开始时间">
                    </el-date-picker>
                </div>
                <div class="exSearch-item">
                    <el-date-picker v-model="advancedSearch.timeSet.closeEnd" type="datetime" style="width:200px;"
                        placeholder="关闭结束时间">
                    </el-date-picker>
                </div>
                <div class="exSearch-item">
                    <el-button type="primary" @click="$_getAdvancedSearch">搜索</el-button>
                    <el-button @click="$_initSearchData">重置</el-button>
                </div>
            </div>
            <div class="exSearch-line">
                <div class="exSearch-item">
                    <el-select v-model="advancedSearch.timeLimit.symbol_duration" style="width:200px;" placeholder="请选择条件">
                        <el-option v-for="item in advancedSearch.timeLimit.list" :key="item.value" :label="item.name"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <div class="exSearch-item">
                    <el-input v-model="advancedSearch.timeLimit.days_duration" style="width:200px;" placeholder="持续天数"
                        :disabled="!advancedSearch.timeLimit.symbol_duration"></el-input>
                </div>
                <div class="exSearch-item">
                    <el-select v-model="advancedSearch.timeLimit.symbol_idle" style="width:200px;" placeholder="请选择条件">
                        <el-option v-for="item in advancedSearch.timeLimit.list" :key="item.value" :label="item.name"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <div class="exSearch-item">
                    <el-input v-model="advancedSearch.timeLimit.days_idle" style="width:200px;" placeholder="滞留天数"
                        :disabled="!advancedSearch.timeLimit.symbol_idle"></el-input>
                </div>
            </div>
        </div>

        <mc-table ref="mc-table" :table-option="tableOption" v-loading="tableOption.loading">
            <template slot="table-components">
                <el-table-column :prop="tableOption.head[0].prop" :label="tableOption.head[0].label" :width="tableOption.head[0].width"
                    v-if="tableOption.head.length>0"></el-table-column>
                <el-table-column :prop="tableOption.head[1].prop" :label="tableOption.head[1].label" :width="tableOption.head[1].width"
                    v-if="tableOption.head.length>0">
                    <template slot-scope="scope">
                        <span class="name" @click="dialog.name.methods.open(scope.row.site_name)">{{scope.row.site_name}}</span>
                    </template>
                </el-table-column>
                <el-table-column :prop="tableOption.head[2].prop" :label="tableOption.head[2].label" :width="tableOption.head[2].width"
                    v-if="tableOption.head.length>0">
                    <template slot-scope="scope">
                        <span class="name" @click="dialog.name.methods.open(scope.row.name)">{{scope.row.name}}</span>
                    </template>
                </el-table-column>
                <el-table-column :prop="tableOption.head[3].prop" :label="tableOption.head[3].label" :width="tableOption.head[3].width"
                    v-if="tableOption.head.length>0"></el-table-column>
                <el-table-column :prop="tableOption.head[4].prop" :label="tableOption.head[4].label" :width="tableOption.head[4].width"
                    v-if="tableOption.head.length>0">
                    <template slot-scope="scope">
                        <span v-if="scope.row.server_type == 1">故障处理</span>
                        <span v-else-if="scope.row.server_type == 2">配置变更</span>
                        <span v-else-if="scope.row.server_type == 3">配件变更</span>
                        <span v-else-if="scope.row.server_type == 4">健康巡检</span>
                    </template>
                </el-table-column>
                <el-table-column :prop="tableOption.head[5].prop" :label="tableOption.head[5].label" :width="tableOption.head[5].width"
                    v-if="tableOption.head.length>0">
                    <template slot-scope="scope">
                        <span v-if="scope.row.problem_type == 1">其他</span>
                        <span v-else-if="scope.row.problem_type == 2">网络</span>
                        <span v-else-if="scope.row.problem_type == 3">存储</span>
                        <span v-else-if="scope.row.problem_type == 4">服务器</span>
                        <span v-else-if="scope.row.problem_type == 5">中间件</span>
                        <span v-else-if="scope.row.problem_type == 6">数据库</span>
                        <span v-else-if="scope.row.problem_type == 7">操作系统</span>
                        <span v-else-if="scope.row.problem_type == 8">硬件故障</span>
                    </template>
                </el-table-column>
                <el-table-column :prop="tableOption.head[6].prop" :label="tableOption.head[6].label" :width="tableOption.head[6].width"
                    v-if="tableOption.head.length>0">
                    <template slot-scope="scope">
                        {{$_handleTime(scope.row.create_at)}}
                    </template>
                </el-table-column>
                <el-table-column :prop="tableOption.head[9].prop" :label="tableOption.head[9].label" :width="tableOption.head[9].width"
                    v-if="advancedSearch.show">
                    <template slot-scope="scope">
                        {{$_handleTime(scope.row.end_at)}}
                    </template>
                </el-table-column>
                <el-table-column :prop="tableOption.head[7].prop" :label="tableOption.head[7].label" :width="tableOption.head[7].width"
                    v-else>
                    <template slot-scope="scope">
                        {{$_handleTime(scope.row.close_at)}}
                    </template>
                </el-table-column>
                <el-table-column :prop="tableOption.head[8].prop" :label="tableOption.head[8].label" :width="tableOption.head[8].width"
                    v-if="tableOption.head.length>0">
                    <template slot-scope="scope">
                        {{$_timeStamp(scope.row.duration)}}
                    </template>
                </el-table-column>
            </template>
        </mc-table>

        <mc-pager :pager-option.sync="pager" ref="close-worklist-pager" @getList="$_getTableList" v-show="!advancedSearch.show"></mc-pager>

        <mc-dialog :dialog-option.sync="dialog.name">
            <template slot="content">
                <mc-label info>{{this.dialog.name.data.key}}</mc-label>
            </template>
        </mc-dialog>
    </div>
</template>

<script>
    export default {
        name: 'user-close-workList',
        data() {
            return {
                searchParmas: '',
                advancedSearch: {
                    show: false,
                    //站点，人，工单类型，事件类型
                    siteList: {
                        list: [],
                        value: [],
                    },
                    userList: {
                        list: [],
                        value: [],
                    },
                    worksheetType: {
                        list: [{
                                name: '故障处理',
                                value: '1',
                            },
                            {
                                name: '配置变更',
                                value: '2',
                            },
                            {
                                name: '配件更换',
                                value: '3',
                            },
                            {
                                name: '健康巡检',
                                value: '4',
                            },
                        ],
                        value: [],
                    },
                    eventType: {
                        list: [{
                                name: '其它',
                                value: '1',
                            },
                            {
                                name: '网络',
                                value: '2',
                            },
                            {
                                name: '存储',
                                value: '3',
                            },
                            {
                                name: '服务器',
                                value: '4',
                            },
                            {
                                name: '中间件',
                                value: '5',
                            },
                            {
                                name: '数据库',
                                value: '6',
                            },
                            {
                                name: '操作系统',
                                value: '7',
                            },
                            {
                                name: '硬件故障',
                                value: '8',
                            },
                        ],
                        value: [],
                    },
                    //创建，关闭时间
                    timeSet: {
                        createStart: '',
                        createEnd: '',
                        closeStart: '',
                        closeEnd: '',
                    },
                    //持续天数，滞留天数
                    timeLimit: {
                        list: [{
                                name: '小于',
                                value: '4',
                            },
                            {
                                name: '小于等于',
                                value: '5',
                            },
                            {
                                name: '等于',
                                value: '1',
                            },
                            {
                                name: '大于',
                                value: '2',
                            },
                            {
                                name: '大于等于',
                                value: '3',
                            },
                        ],
                        symbol_duration: '',
                        symbol_idle: '',
                        days_duration: '',
                        days_idle: '',
                    },
                    is_paginate: true,
                    page: 1,
                    per_page: 20,
                    //不确定数值
                    noData: '',
                    status: '3'
                },
                exSearch: false,
                pager: {
                    page: 1,
                    per_page: 10,
                    per_pages: [10, 20, 30, 40, 50],
                    total: 0,
                },
                tableOption: {
                    loading: false,
                    index: {
                        disable: true,
                    },
                    operations: {
                        disable: true,
                        label: "操作",
                        items: [{
                            label: "查看",
                            type: "default",
                            size: 'mini',
                            click: (index, row) => {
                                this.$_goToDetails(row);
                            },
                        }, ],
                    },
                    head: [{
                            prop: "id",
                            label: "工单号",
                            width: "120",
                        },
                        {
                            prop: "site_name",
                            label: "站点名称",
                            width: "",
                        },
                        {
                            prop: "name",
                            label: "标题",
                            width: "",
                        },
                        {
                            prop: "creater_name",
                            label: "创建者",
                            width: "80",
                        },
                        {
                            prop: "problem_type",
                            label: "工单类型",
                            width: "80",
                        },
                        {
                            prop: "server_type",
                            label: "事件类型",
                            width: "80",
                        },
                        {
                            prop: "create_at",
                            label: "开始时间",
                            width: "140",
                        },
                        {
                            prop: "close_at",
                            label: "结束时间",
                            width: "140",
                        },
                        {
                            prop: "duration",
                            label: "持续时间",
                            width: "130",
                        },
                        {
                            prop: "end_at",
                            label: "结束时间",
                            width: "140",
                        },
                    ],
                    data: [],
                },
                dialog: {
                    name: {
                        visible: false,
                        title: "详情",
                        style: {
                            showConfirm: false,
                            showCancel: false,
                        },
                        methods: {
                            open: (item) => {
                                this.dialog.name.visible = true;
                                this.dialog.name.data.key = item;
                            },
                        },
                        data: {
                            key: "",
                        },
                    },
                },
            }
        },
        mounted() {
            this.$_getTableList();
            this.$_getSiteList();
            this.$_getUserList();
        },
        methods: {
            $_getTableList: async function () {
                this.tableOption.loading = true;
                let params = {
                    page: this.pager.page,
                    per_page: this.pager.per_page,
                    query: this.searchParmas
                }
                let data = await this.$api.userCloseWorkList.getList.getCloseWorkList.call(this, params);
                if (data !== false) {
                    this.pager.total = data.total;
                    this.tableOption.data = data.data;
                }
                this.tableOption.loading = false;
            },
            $_getSiteList: async function () {
                let params = {}
                let data = await this.$api.userCloseWorkList.getList.getSite.call(this, params);
                if (data !== false) {
                    this.advancedSearch.siteList.list = data;
                }
            },
            $_getUserList: async function () {
                let params = {}
                let data = await this.$api.userCloseWorkList.getList.getUser.call(this, params);
                if (data !== false) {
                    this.advancedSearch.userList.list = data;
                }
            },
            $_getAdvancedSearch: async function () {
                let params = {
                    //站点，人，工单类型，事件类型
                    site_name: this.advancedSearch.siteList.value,
                    editor_name: this.advancedSearch.userList.value,
                    server_type: this.advancedSearch.worksheetType.value,
                    problem_type: this.advancedSearch.eventType.value,
                    //创建，关闭时间
                    create_start: this.$_handleTimeFormat(this.advancedSearch.timeSet.createStart),
                    create_end: this.$_handleTimeFormat(this.advancedSearch.timeSet.createEnd),
                    close_start: this.$_handleTimeFormat(this.advancedSearch.timeSet.closeStart),
                    close_end: this.$_handleTimeFormat(this.advancedSearch.timeSet.closeEnd),
                    //持续天数，滞留天数
                    duration_symbol: this.advancedSearch.timeLimit.symbol_duration,
                    duration_days: this.advancedSearch.timeLimit.days_duration,
                    idle_symbol: this.advancedSearch.timeLimit.symbol_idle,
                    idle_days: this.advancedSearch.timeLimit.days_idle,
                    //分页
                    is_paginate: true,
                    page: this.advancedSearch.page,
                    per_page: this.advancedSearch.per_page,
                    //未知数据
                    status: "3",
                };
                let data = await this.$api.userCloseWorkList.getList.getAdvancedSearch.call(this, params)
                if (data !== false) {
                    this.tableOption.data = data.data;
                    this.advancedSearch.show = true;
                }
            },
            $_handleTimeFormat(time) {
                if (!time) return ''
                var date = new Date(Date.parse(time) + 8 * 60 * 60 * 1000)
                let year = date.getFullYear();
                let month = date.getMonth() + 1;
                let day = date.getDate();
                let hour = date.getHours();
                let minute = date.getMinutes();
                let second = date.getSeconds();
                let handledDate =
                    `${year}-${month>10?month:('0'+month)}-${day>10?day:('0'+day)} ${hour>10?hour:('0'+hour)}:${minute>10?minute:('0'+minute)}:${second>10?second:('0'+second)}`
                return handledDate;
            },
            $_initSearchData() {
                for (let i in this.advancedSearch) {
                    if (typeof (this.advancedSearch) == 'object') {
                        if (this.advancedSearch[i].value) this.advancedSearch[i].value = [];
                    }
                }
                for (let i in this.advancedSearch.timeSet) {
                    this.advancedSearch.timeSet[i] = ''
                }
                for (let i in this.advancedSearch.timeLimit) {
                    if (typeof (this.advancedSearch.timeLimit[i]) == 'string') this.advancedSearch.timeLimit[i] = '';
                }
                this.advancedSearch.show = false;
                this.$_getTableList();
            },
            $_timeStamp(time) {
                let day = parseInt(time / 60 / 24);
                let hour = parseInt(time / 60 % 24);
                let min = parseInt(time % 60);
                time = "";
                if (day > 0) {
                    time = day + "天";
                }
                if (hour > 0) {
                    time += hour + "小时";
                }
                if (min > 0) {
                    time += parseFloat(min) + "分钟";
                }
                return time
            },
            $_handleTime(item) {
                let time = Date.parse(item);
                let date = new Date(time + 8 * 60 * 60 * 1000)
                let Y = date.getFullYear() + '-';
                let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
                let D = date.getDate() + ' ';
                let h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
                let m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
                let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
                return Y + M + D + h + m + s
            },
            $_goToDetails(row) {
                this.$router.push({
                    name: 'user-edit-workList',
                    params: {
                        id: row.id,
                        sort: 2
                    }
                });
            }
        },
        watch: {
            pager: {
                deep: true,
                handler: function () {
                    this.$_getTableList();
                },
            },
        }
    }
</script>

<style lang="less" scoped>
    .close-workList {
        width: 100%;

        .exSearch-row {
            width: 100%;
            padding: 20px;
            padding-top: 0;

            .exSearch-line {
                display: inline-flex;
                width: 100%;
                margin-bottom: 10px;

                .exSearch-item {
                    margin-right: 20px;
                }
            }
        }

        .name {
            cursor: pointer;
            color: #1890FF;
            min-width: 200px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
</style>